export default __webpack_public_path__ + "static/media/truck.b3db4ccf.svg";